import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const data = {
  title: 'Domain &',
  subtitle: 'Hosting',
  tagline: 'Reliable Online Presence',
  // icon: '🖥️',
  icon: '',

  heroDesc: 'Get your business online with the right domain name and reliable, high-speed hosting. We handle everything from domain registration to server management.',
  mainStat: '99.9%',
  mainStatLabel: 'Uptime guarantee on all hosting plans',
  subStats: [{ value: '24/7', label: 'Technical Support' }, { value: '<1s', label: 'Server Response Time' }],
  features: [
    { icon: '🌐', title: 'Domain Registration', desc: 'Find and register the perfect domain name for your business.' },
    { icon: '⚡', title: 'Fast SSD Hosting', desc: 'High-speed SSD servers that load your website in milliseconds.' },
    { icon: '🔒', title: 'Free SSL Certificate', desc: 'HTTPS security included with all hosting plans at no extra cost.' },
    { icon: '📧', title: 'Business Email', desc: 'Professional email addresses with your domain name (you@yourbusiness.com).' },
    { icon: '🔄', title: 'Daily Backups', desc: 'Automatic daily backups so your data is always safe and recoverable.' },
    { icon: '📊', title: 'Control Panel', desc: 'Easy-to-use cPanel dashboard to manage your website and files.' },
  ],
  benefits: [
    { title: 'Professional Online Identity', desc: 'A custom domain builds instant credibility and brand recognition.' },
    { title: 'Fast Loading Speed', desc: 'Speed directly impacts SEO rankings and user experience.' },
    { title: 'Complete Data Security', desc: 'SSL, firewalls, and regular backups keep your data protected.' },
    { title: 'One-Stop Service', desc: 'Domain + hosting + email all managed by one trusted partner.' },
  ],
  process: [
    { title: 'Domain Search', desc: 'We help you find and secure the perfect domain name for your brand.' },
    { title: 'Hosting Setup', desc: 'Server configured and optimized for your specific website requirements.' },
    { title: 'Website Migration', desc: 'Existing website migrated seamlessly with zero downtime.' },
    { title: 'Email Configuration', desc: 'Professional business email accounts set up and tested.' },
    { title: 'Ongoing Monitoring', desc: '24/7 uptime monitoring with immediate alerts for any issues.' },
  ],
  whyChoose: [
    { icon: '⚡', title: 'Blazing Fast Servers', desc: 'Our servers are optimized for speed, reliability, and performance.' },
    { icon: '🔒', title: 'Bank-Grade Security', desc: 'Enterprise security features to protect your website and customer data.' },
    { icon: '📞', title: '24/7 Support', desc: 'Round-the-clock technical support whenever you need it.' },
    { icon: '💰', title: 'Competitive Pricing', desc: 'Premium hosting at affordable prices with transparent renewal rates.' },
  ],
  reviews: [
    { name: 'Preethi Nair', role: 'E-commerce Seller', text: 'My website used to be slow. After switching to DMS hosting, load times dropped from 8s to 1.2s!' },
    { name: 'Manish Tiwari', role: 'Restaurant Owner', text: 'Zero downtime in 2 years and business email has been absolutely flawless.' },
    { name: 'Lalitha Rao', role: 'School Principal', text: 'They handled our entire domain and hosting setup painlessly. Highly recommended.' },
  ],
  faq: [
    { q: 'Do you register .in domains?', a: 'Yes, we register all major domain extensions: .com, .in, .co.in, .net, .org, and more.' },
    { q: 'Can I migrate my existing website?', a: 'Absolutely! We handle complete website migrations with zero downtime.' },
    { q: 'What if my website goes down?', a: 'Our 24/7 monitoring catches issues instantly and our support team resolves them immediately.' },
  ],
};

export default function DomainHosting() {
  return <ServiceTemplate data={data} />;
}
